import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";

import { QUERY_DIGITAL_RECEPTION_ACTIVE_LANGUAGES } from "../../../../../config/graphql/query";

/**
 * The language a set's questions are listed in: the CMS's own when the reception offers it, the
 * reception's first otherwise -- a CMS in Dutch over an English-only reception would list blanks.
 *
 * Undefined until the reception's languages are known, so the list is never drawn in a language it
 * is about to leave.
 */
export const useListLanguage = (screenId?: string): string | undefined => {
  const { i18n } = useTranslation();

  const { data } = useQuery<{ digitalReception: { languages: string[] } }>(
    QUERY_DIGITAL_RECEPTION_ACTIVE_LANGUAGES,
    {
      variables: { id: screenId },
      skip: !screenId,
    },
  );

  const languages = data?.digitalReception?.languages;

  if (!languages?.length) return undefined;

  return languages.includes(i18n.language) ? i18n.language : languages[0];
};

export default useListLanguage;
